import { Controller } from "@hotwired/stimulus"

// A title with a pencil beside it (the home's settings modal): the pencil swaps
// the title for its form, focused and selected; Enter submits, Escape puts the
// title back unchanged.
export default class extends Controller {
    static targets = ["view", "form", "input"]

    edit(event) {
        event?.preventDefault()
        this.viewTarget.hidden = true
        this.formTarget.hidden = false
        this.inputTarget.focus()
        this.inputTarget.select()
    }

    keydown(event) {
        if (event.key !== "Escape") return
        event.preventDefault()
        event.stopPropagation()
        this.inputTarget.value = this.inputTarget.defaultValue
        this.formTarget.hidden = true
        this.viewTarget.hidden = false
    }
}
